export default __webpack_public_path__ + "static/media/cv.29a0e901.svg";